import React, { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router';

import pages from 'pages';
import { CheckEmail } from 'modules/auth/screens/CheckEmail/CheckEmail';
import { CreatePassword as ResetPassword } from 'modules/auth/screens/CreatePassword/CreatePassword';
import { Login } from 'modules/auth/screens/Login/Login';
import { ForgotPassword } from 'modules/auth/screens/ForgotPassword/ForgotPassword';
import { Registration } from 'modules/auth/screens/Registration/Registration';
import { Verification } from 'modules/auth/screens/Verification/Verification';
import { Password } from 'modules/auth/screens/Password/Password';
import { TooManyAttempts } from 'modules/auth/screens/TooManyAttempts/TooManyAttempts';
import { Layout } from 'shared/components/Layout/Layout';
import { LoadingLogo } from 'shared/components/Modal/LoadingLogo';

const ClaimAccount = lazy(() => import('modules/auth/screens/ClaimAccount/ClaimAccount'));

export const Auth: RouteObject[] = [
  {
    element: <Layout hasFooter isAuthScreen />,
    children: [
      {
        index: true,
        element: <Navigate to={`/${pages.LOGIN}`} replace />,
      },
      {
        path: pages.LOGIN,
        element: <Login />,
      },
      { path: pages.FORGOT_PASSWORD, element: <ForgotPassword /> },
      { path: pages.RESET_PASSWORD, element: <ResetPassword /> },
      { path: pages.CHECK_EMAIL, element: <CheckEmail /> },
      {
        path: pages.CLAIM_ACCOUNT,
        element: (
          <Suspense fallback={<LoadingLogo />}>
            <ClaimAccount />
          </Suspense>
        ),
      },
      { path: pages.REGISTRATION, element: <Registration /> },
      { path: pages.VERIFICATION, element: <Verification /> },
      { path: pages.PASSWORD, element: <Password /> },
      { path: pages.TOO_MANY_ATTEMPTS, element: <TooManyAttempts /> },
    ],
  },
];

export default Auth;
